// 有料短视频
export const getYlAllData = state => state.youliao.allData


// WEBPACK FOOTER //
// ./src/store/getters.js